import { CalendarDate } from 'src/utils/ltDate';
import { formatDateToDayShort } from './dateUtils';
import { pluralizeAdults, pluralizeNights } from './pluralizeUtils';

type OrderForSummary = {
  id?: number;
  package?: {
    nights_count?: number;
    adults_count?: number;
    dates_info?: {
      start_date?: string;
    };
  };
};

// TODO Описать типы для Order
// https://leveltravel.atlassian.net/browse/LT-22315
export const getOrderHeaderLabel = (order: OrderForSummary) =>
  `Заказ №${order?.id}`;

export const getOrderDescription = (order: OrderForSummary) => {
  const nights = order?.package?.nights_count ?? 0;
  const startDate =
    order?.package?.dates_info?.start_date ||
    CalendarDate.format(CalendarDate.fromNativeDate(new Date()), 'yyyy-MM-dd');
  const adults = order?.package?.adults_count ?? 0;

  return `${nights} ${pluralizeNights(nights)} с ${formatDateToDayShort(
    startDate,
  )} / ${adults} ${pluralizeAdults(adults)}`;
};
